import { styled } from '@mui/material/styles'

export const Sidebar = styled('aside')(({ theme }) => ({
  background: '#211843',
  color: '#fff',
  display: 'flex',
  flexDirection: 'column',
  flex: '0 0 248px',
  height: '100dvh',
  minHeight: 0,
  overflowY: 'auto',
  padding: theme.spacing(2, 1.5),
  transition: 'flex-basis 160ms ease',
  '@media (max-width: 760px)': {
    flexBasis: 72,
    padding: theme.spacing(2, 0.75)
  }
}))

export const Brand = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(1.25),
  minHeight: 48,
  padding: theme.spacing(0, 1),
  '@media (max-width: 760px)': {
    justifyContent: 'center',
    padding: 0
  }
}))
